import React, {Component} from 'react'
import Button from '@material-ui/core/Button';
import AddBoxIcon from '@material-ui/icons/AddBox';
import DeleteArea from './DeleteArea'
//import WarningDialog from '../../FunctionArea/WarningDialog'
import { withStyles } from '@material-ui/core/styles';
import LinkedList from '../../FunctionArea/LinkedList';
import FirstStageOption from './FirstStageOption'
import SecondStageOptionGroup from './SecondStageOptionGroup'
import {Prompt} from 'react-router-dom'
import Modal from '@material-ui/core/Modal'
import StaticPageCheck from './StaticPageCreate/StaticPageCheck'
import {server_ip} from '../../../ipAddress'

const wStyles = theme => ({
    textLink:{
        //height:30,
        width:"90%",
        color:"white",
        fontFamily:"Microsoft JhengHei",
        borderStyle:"soild",
        borderWidth:1,
        borderColor:"black",
        backgroundColor:"#2783c4",
        textAlign:"center",
        fontSize:15,
        lineHeight:"30px",
        margin:5,
        '&:hover':{
            color:"black",
            cursor:"pointer"
        }  
    }
})

class StaticPageBody extends Component {
    constructor(props) {
        super(props)
        this.state = {
            showWarningDialog:false,
            showStaticPageCheck:false,
            firstStageOptions:null,
            mousePos:{
                x:0,
                y:0
            },
            containerDragging:{
                status:false,
                sequence:null,
                conID:null
            },
            insertOption:{
                id:null,
                sequence:null
            },
            deleteOption:false,
        }
    }

    componentDidMount(){
        this.initialState()
    }

    componentWillUnmount(){
        if(this.props.sessionAvaliable)
        {
            this.updateStaticPageList()
        }
    }

    publicStaticPage=()=>{
        this.setState({
            showStaticPageCheck:true
        })
    }

    initialState=async()=>{
        let msg = await fetch(server_ip+'/api/staticPage/get/OptionLinkedList', {
            method:"get"
        })

        let output = await msg.json()
        //console.log("output : ", output[0])
        
        let finalList = this.returnLinkedList(output[0] && output[0].Temp_StaticPage_LinkedList) 

        this.setState({
            firstStageOptions:finalList
        })
    }

    returnLinkedList =(list)=> {
        let cloneL = new LinkedList()
        
        if(list)
        {
            if(list.head)
            {
                let current = list.head
                while(current)
                {
                    let tempNodeData = {...current.data}
                    cloneL.insertLast(tempNodeData)
                    current = current.next
                }
            }
        }
        
        return cloneL
    }

    createFirstStageOption=()=>{
        console.log("createFirstStageOption...")
        if(this.state.firstStageOptions){
            let tempLinkedList = this.state.firstStageOptions
            let tempArray = []
            let countI = -1
            for(let i=0;i< tempLinkedList.length;i++)
            {
                //console.log("i : ",i)
                //console.log(tempLinkedList.getAt(i))
                tempArray.push(tempLinkedList.getAt(i))
                //return( <FirstStageOption optionInfo={tempLinkedList.getAt(i)}/>)
            }
            return tempArray.map(option=>{
                countI= countI+1
                return (<FirstStageOption key={option.id} mousePos={this.state.mousePos} optionInfo={option} sequence={countI} bgColor={option.color} containerDragging={this.containerDragging} otherDragging={this.state.containerDragging.conID} getHoverMsg={this.getHoverMsg} getTitleAndRoute={this.getTitleAndRoute}/>)
            })
        }
        else
        {
            return null
        }
    }

    createSecondStageGroup=()=>{
        if(this.state.firstStageOptions){
            let tempLinkedList = this.state.firstStageOptions
            let tempArray = []
            let countI = -1
            for(let i=0;i< tempLinkedList.length;i++)
            {
                //console.log("i : ",i)
                //console.log(tempLinkedList.getAt(i))
                tempArray.push(tempLinkedList.getAt(i))
                //return( <FirstStageOption optionInfo={tempLinkedList.getAt(i)}/>)
            }
            return tempArray.map(option=>{
                countI= countI+1
                return (<SecondStageOptionGroup key={option.id} userID={this.props.userID} optionInfo={option} sequence={countI} bgColor={option.color} getSecondStageOptionList={this.getSecondStageOptionList} editPage={this.editPage} sessionAvaliable={this.props.sessionAvaliable}/>)
            })
        }
        else
        {
            return null
        }
    }

    updateStaticPageList=async()=>{
        
        let linkedListJsonStringfy = new Promise((resolve,reject)=>{
            let myJson = JSON.stringify(this.state.firstStageOptions)
            resolve(myJson)
        })

        Promise.all([linkedListJsonStringfy]).then(async(promiseArray)=>{
            let formData = new FormData()
            formData.append("LinkedList", promiseArray[0])
            console.log("formDate : ")
            console.log(promiseArray[0])
            let msg = await fetch(server_ip+'/api/staticPage/post/OptionLinkedList', {
                body:formData,
                method:"post"
            })
    
            let output = await msg
            console.log(output)
        })
    }

    containerDragging = (msg) => {
        //console.log('ControllerUnitLayout onContainerDragging')
        //console.log('conID : ',msg.conID, 'booling : ',msg.containerDragging)
        //console.log(msg.position)
  
        if(msg.containerDragging)
        {
            console.log('onContainerDragging A1')
            this.setState({
                firstStageOptions:this.updateTitleAndRoute(msg),
                containerDragging:{
                    status:msg.containerDragging,
                    sequence:msg.sequence,
                    conID:msg.conID
                },
                needMousePos:true,
            })            
        }
        else
        {   
            console.log('onContainerDragging A2')
            if(this.state.insertOption.id)
            {
                console.log('onContainerDragging A2-1')
                let changeInfo = {
                    insertToIndex:this.state.insertOption.sequence,
                    selectAtIndex:this.state.containerDragging.sequence,
                }

                this.setState({
                    containerDragging:{
                        status:false,
                        sequence:null,
                        conID:null
                    },
                    insertOption:{
                        id:null,
                        sequence:null
                    }
                },()=>{
                    this.reorderLinkedList(changeInfo)
                })
            }
            else
            {
                console.log('onContainerDragging A2-2')
                if(this.state.deleteOption)
                {
                    console.log('onContainerDragging A2-2-1')
                    let tempLinkedList = this.state.firstStageOptions.cloneList()
                    tempLinkedList.removeAt(this.state.containerDragging.sequence)
                    this.setState({
                        firstStageOptions:tempLinkedList,
                        deleteOption:false,
                        containerDragging:{
                            status:false,
                            sequence:null,
                            conID:null
                        },
                        needMousePos:false,
                        mousePos:{
                            x:0,
                            y:0
                        }
                    })
                }
                else
                {
                    console.log('onContainerDragging A2-2-2')
                    this.setState({
                        containerDragging:{
                            status:false,
                            sequence:null,
                            conID:null
                        },
                        needMousePos:false,
                        mousePos:{
                            x:0,
                            y:0
                        }
                    })
                }
            }
        }
    }

    getSecondStageOptionList=(msg)=>{
        let testData = msg.list.getAt(0)
        console.log("testData")
        console.log(testData)
        let tempLinkedList = this.state.firstStageOptions.cloneList()
        let tempOption = tempLinkedList.getAt(msg.sequence)
        let tempObj = {
            id:tempOption.id,
            title:tempOption.title,
            route:tempOption.route,
            color:tempOption.color,
            list:msg.list
        }

        tempLinkedList.removeAt(msg.sequence)
        tempLinkedList.insertAtPrefix(tempObj,msg.sequence)
        this.setState({
            firstStageOptions:tempLinkedList
        })
    }

    getTitleAndRoute=(msg)=>{
        this.setState({
            firstStageOptions:this.updateTitleAndRoute(msg),
            containerDragging:{
                status:false,
                sequence:null,
                conID:null
            },
            needMousePos:false,
            insertOption:{
                id:null,
                sequence:null
            },
            deleteOption:false
        })
    }

    updateTitleAndRoute=(msg)=>{
        let tempLinkedList = this.state.firstStageOptions.cloneList()
        let tempOption = tempLinkedList.getAt(msg.sequence)
        let tempObj = {
            id:msg.conID,
            title:msg.title,
            route:msg.route,
            color:msg.color,
            list:tempOption.list
        }

        tempLinkedList.removeAt(msg.sequence)
        tempLinkedList.insertAtPrefix(tempObj,msg.sequence)
        return tempLinkedList
    }

    reorderLinkedList=(changeInfo)=>{
        let tmpLinkedList = this.state.firstStageOptions.cloneList()
        if(changeInfo.insertToIndex === "last")
        {
            let targetIndex = tmpLinkedList.length-1
            tmpLinkedList.shiftToSurfix(changeInfo.selectAtIndex,targetIndex)
            console.log("tmpLinkedList")
            console.log(tmpLinkedList)
            this.setState({
                firstStageOptions:tmpLinkedList
            })
        }
        else
        {
            if(changeInfo.selectAtIndex<changeInfo.insertToIndex)
            {
                tmpLinkedList.shiftToPrefix(changeInfo.selectAtIndex,changeInfo.insertToIndex)
                console.log("tmpLinkedList")
                console.log(tmpLinkedList)
                this.setState({
                    firstStageOptions:tmpLinkedList
                })
            }
            else
            {
                tmpLinkedList.shiftToPrefix(changeInfo.selectAtIndex,changeInfo.insertToIndex)
                console.log("tmpLinkedList")
                console.log(tmpLinkedList)
                this.setState({
                    firstStageOptions:tmpLinkedList
                })
            }
        }
    }

    getHoverMsg = (msg) => {
        console.log("getOption...")
        console.log(msg)
        if(msg.status)
        {
            if(msg.id !== this.state.insertOption.id)
            {
                this.setState({
                    insertOption:msg
                })
            }
        }
        else
        {
            if(this.state.insertOption.id)
            {
                this.setState({
                    insertOption:{
                        id:null,
                        sequence:null
                    }
                })
            }
        }
    }

    onMouseMove=(e)=>{
        //console.log("ComponentLayot onMouseMove...")
        if(this.state.needMousePos)
        { 
            this.setState({
                mousePos:{
                    x:e.clientX,
                    y:e.clientY
                },
            })
        }
    }

    confirmDeleteRow = async()=>{

        this.setState({
            showWarningDialog:false,
   
        })             
    }

    cancelDeleteRow =()=>{
        this.setState({
            showWarningDialog:false,
        })
    }

    addNewFirst=()=>{
        console.log('addNewFirst...')
        let tempLinkedList = this.state.firstStageOptions.cloneList()
        let id = this.getID()
        let color = this.getHashColor(this.makeid(10))
        let tempObj = {
            id:id,
            title:"請輸入第一階標題",
            route:"DefaultUrl",
            color:color,
            list:null
        }
            
        tempLinkedList.insertLast(tempObj)
        console.log('tempLinkedList...')
        console.log(tempLinkedList)
        this.setState({
            firstStageOptions:tempLinkedList
        })    
    }

    getID=()=>{
        if(this.state.firstStageOptions)
        {
            if(this.state.firstStageOptions.head)
            {
                let tempArray = this.state.firstStageOptions.transArray('id')
                console.log('id array : ')
                console.log(tempArray)
                let finalID = Math.max(...tempArray)+1
                return finalID
            }
            else
            {
                return 1
            }
        }
        else
        {
            return 1
        }
    }

    getSysID=()=>{
        let d = new Date()
        return d.getTime()+this.props.userID
    }

    makeid=(length)=>{
        let result = '';
        let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let charactersLength = characters.length;
        for ( let i = 0; i < length; i++ ) 
        {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }
     
    getHashColor=(str)=>{
        if(str)
        {
            var hash = 0;
            for (var i = 0; i < str.length; i++) {
                hash = str.charCodeAt(i) + ((hash << 5) - hash);
            }
  
            let c = (hash & 0x00FFFFFF)
            .toString(16)
            .toUpperCase();
            let tempString = "00000".substring(0, 6 - c.length) + c;
            return "#"+tempString
        }
        else
        {
            return "#000000"
        }
    }

    getDeleteSequence=(msg)=>{
        if(this.state.deleteOption !== msg)
        {
            this.setState({
                deleteOption:msg
            })
        }
    }

    editPage=(msg)=>{
        this.props.editPage(msg)
    }

    closeStaticPageCheckModal=()=>{
        this.setState({
            showStaticPageCheck:false
        })
    }

    staticPageAllCheck=async()=>{
        
        let staticPageCheck = await this.staticPageCheck()
        let firstStageOptionCheck = this.firstStageOptionCheck()
        let secondStageOptionCheck = this.secondStageOptionCheck()

        console.log(firstStageOptionCheck)
        console.log(secondStageOptionCheck)
        console.log(staticPageCheck)

        let checkObj = {
            firstStageOptionCheck:firstStageOptionCheck,
            secondStageOptionCheck:secondStageOptionCheck,
            stagePageCheck:staticPageCheck
        }

        return checkObj
    }

    firstStageOptionCheck=()=>{
        let firstStageOptionArray = this.state.firstStageOptions
        let resultOfTitleCheck_tempArray = firstStageOptionArray.transArray("title")
        let resultOfRouteCheck_tempArray = firstStageOptionArray.transArray("route")

        let resultOfOptionEmptyCheck
        let resultOfTitleDeafultCheck
        let resultOfRouteDeafultCheck
        let resultOfTitleUniqueCheck
        let resultOfRouteUniqueCheck

        if(resultOfTitleCheck_tempArray.length>0)
        {
            resultOfOptionEmptyCheck = true
        }
        else
        {
            resultOfOptionEmptyCheck = false
        }

        if(resultOfTitleCheck_tempArray.find(title=>title === "請輸入第一階標題"))
        {
            resultOfTitleDeafultCheck = false
        }
        else
        {
            resultOfTitleDeafultCheck = true
        }

        if(resultOfRouteCheck_tempArray.find(route=>route === "DefaultUrl"))
        {
            resultOfRouteDeafultCheck = false
        }
        else
        {
            resultOfRouteDeafultCheck = true
        }

        resultOfTitleUniqueCheck = !this.checkDuplicateElementInArray(resultOfTitleCheck_tempArray)
        resultOfRouteUniqueCheck = !this.checkDuplicateElementInArray(resultOfRouteCheck_tempArray)

        let msg={
            OptionEmptyCheck:resultOfOptionEmptyCheck,
            TitleDeafultCheck:resultOfTitleDeafultCheck,
            RouteDeafultCheck:resultOfRouteDeafultCheck,
            TitleUniqueCheck:resultOfTitleUniqueCheck,
            RouteUniqueCheck:resultOfRouteUniqueCheck
        }

        return msg
    }

    secondStageOptionCheck=()=>{
        let secondStageOptionListArray = this.state.firstStageOptions.transArray("list")
        
        let resultOfSecondOptionEmptyCheck = true
        let resultOfSecondOptionTitleDeafultCheck = true
        let resultOfSecondOptionRouteDeafultCheck = true
        let resultOfSecondOptionTitleUniqueCheck = true
        let resultOfSecondOptionRouteUniqueCheck = true
        
        //console.log(secondStageOptionListArray)
        for(let i = 0; i<secondStageOptionListArray.length; i++)
        {
            console.log("A")
            console.log("index : ",i)
            let list = secondStageOptionListArray[i]
            console.log(list)
            console.log(secondStageOptionListArray[i])
            if(list)
            {
                console.log("A-1")
                if(!list.head)
                {
                    console.log("A-1-1")
                    resultOfSecondOptionEmptyCheck = false
                }
                else
                {
                    console.log("A-1-2")
                    console.log(list)
                    let tempList = this.returnLinkedList(list)
                    //console.log(tempList.getAt(0))
                    //console.log(list.getAt(0))
                    let resultOfTitleCheck_tempArray = tempList.transArray("title")
                    let resultOfRouteCheck_tempArray = tempList.transArray("route")

                    if(resultOfTitleCheck_tempArray.find(title=>title === "請輸入第二階標題"))
                    {
                        resultOfSecondOptionTitleDeafultCheck = false
                    }                

                    if(resultOfRouteCheck_tempArray.find(route=>route === "DefaultRoute"))
                    {
                        resultOfSecondOptionRouteDeafultCheck = false
                    }

                    if(this.checkDuplicateElementInArray(resultOfTitleCheck_tempArray))
                    {
                        resultOfSecondOptionTitleUniqueCheck = false
                    }
                    
                    if(this.checkDuplicateElementInArray(resultOfRouteCheck_tempArray))
                    {
                        resultOfSecondOptionRouteUniqueCheck = false
                    }
                }
            }
            else
            {
                console.log("A-2")
                resultOfSecondOptionEmptyCheck = false
            }
        }

        let msg={
            SecondOptionEmptyCheck:resultOfSecondOptionEmptyCheck,
            SecondOptionTitleDeafultCheck:resultOfSecondOptionTitleDeafultCheck,
            SecondOptionRouteDeafultCheck:resultOfSecondOptionRouteDeafultCheck,
            SecondOptionTitleUniqueCheck:resultOfSecondOptionTitleUniqueCheck,
            SecondOptionRouteUniqueCheck:resultOfSecondOptionRouteUniqueCheck
        }

        return msg
    }

    staticPageCheck=async()=>{
        console.log("staticPageCheck")
        let secondStageOptionListArray = this.state.firstStageOptions.transArray("list")

        let totalCheckReport = new Promise((resolve,reject)=>{

            let checkReportFirst = secondStageOptionListArray.map(async(list)=>{
                if(list)
                {
                    console.log("A-1")
                    if(!list.head)
                    {
                        console.log("A-1-1")                 
                        return "empty"
                    }
                    else
                    {
                        console.log("A-1-2")
                        let tempList = this.returnLinkedList(list)
                        let compositionCheck_tempArray = tempList.transArray("id")
    
                        let checkReportSecond = new Promise((resolve,reject)=>{                  
                            let errorArray = compositionCheck_tempArray.map(async(id)=>{
                                let compositionArray = await this.fetchStaticPageInfoFromAPI(id)
                                if(compositionArray.length > 0)
                                {
                                    let report = "ok"
                                    compositionArray.forEach(composition=>{
                                        console.log("composition :")
                                        console.log(composition)
                                        
                                        if(composition.type === "image")
                                        {
                                           
                                            //resultOfImageDivCheck = true
                                            if(!composition.imageAttributes)
                                            {
                                                report = "image"
                                            }
                                            else
                                            {
                                                if(!composition.imageAttributes.imageUrl)
                                                {
                                                    report = "image"
                                                }
                                            }
                                        }
                                        else if(composition.type === "text")
                                        {
                                            if(!composition.textAttributes)
                                            {
                                                report = "text"
                                            }
                                        }
                                    })   
                                    return report 
                                }
                                else
                                {
                                    return "empty"
                                }
                            })
                            resolve(Promise.all(errorArray))
                        }) 

                        return checkReportSecond
                    }
                }
                else
                {
                    console.log("A-2")
                    return "empty"            
                    //resultOfCompositionEmptyCheck = null
                }
            })

            resolve(Promise.all(checkReportFirst))

        }) 
   
        let temp = await totalCheckReport   
        let finalCheckReport = temp.flat()

        let resultOfCompositionEmptyCheck = true
        let resultOfImageDivCheck = true    
        let resultOfTextDivCheck = true

        finalCheckReport.forEach(report=>{
            if(report === "empty")
            {
                resultOfCompositionEmptyCheck = false
            }
            else if(report === "image")
            {
                resultOfImageDivCheck = false
            }
            else if(report === "text")
            {
                resultOfTextDivCheck = false
            }
        })

        let msg = {
            CompositionEmptyCheck : resultOfCompositionEmptyCheck,
            ImageDivCheck : resultOfImageDivCheck,
            TextDivCheck : resultOfTextDivCheck,
        }
    
        return msg
    }

    fetchStaticPageInfoFromAPI = async(StaticPage_SysID)=>{
        let msg = await fetch(server_ip+'/api/staticPage/get/Page/'+StaticPage_SysID)
        let outputArray = []
        
        if(msg.ok)
        {
            let output = await msg.json() 
            if(output[0])
            {
                outputArray = output[0].Temp_StaticPage_CompositionSettings
            }
        }  
        return outputArray
    }


    checkDuplicateElementInArray=(inputArray)=>{
        return new Set(inputArray).size !== inputArray.length
    }

    updateDB=()=>{
        this.setState({
            showStaticPageCheck:false
        },()=>{
            let sysIDList = this.getSysIDList(this.state.firstStageOptions)
            let tempLinkedList = this.state.firstStageOptions
            let linkedListJsonStringfy = new Promise((resolve,reject)=>{
                let myJson = JSON.stringify(tempLinkedList)
                resolve(myJson)
            })

            Promise.all([linkedListJsonStringfy]).then(async(promiseArray)=>{
                let formData = new FormData()
                formData.append("LinkedList", promiseArray[0])
                formData.append("SPageSysIDListLength", sysIDList.length)
                formData.append("SPageSysIDList", sysIDList.join())
                //console.log("formDate : ")
                //console.log(promiseArray[0])
                let msg = await fetch(server_ip+'/api/staticPage/post/PublicStaticPage', {
                    body:formData,
                    method:"post"
                })

                let output = await msg
                console.log(output)
                if(output.statusText === "OK")
                {
                    alert("已發布靜態頁面")
                }
            })
        })
    }

    getSysIDList=(linkerList)=>{
        let tempList = linkerList
        let listArray = []
        let firstStageCurrentNode =  tempList.head
        while(firstStageCurrentNode)
        {
            let secondStageCurrentNode = firstStageCurrentNode.data.list.head
            while(secondStageCurrentNode) 
            {
                listArray.push(secondStageCurrentNode.data.id)
                secondStageCurrentNode = secondStageCurrentNode.next
            }
            firstStageCurrentNode = firstStageCurrentNode.next
        }
        //console.log("getSysIDList")
        //console.log(listArray)
        return listArray
    }

    render(){
        const {classes} = this.props;
        let firstStageParentContainerStyle = {
            width: "30%",
            height: "82vh",
            textAlign: "center",
            margin: "10px",
        }

        let secondStageParentContainerStyle = {
            width: "70%",
            height: "82vh",
            backgroundColor: "beige",
            borderRadius: "5px",
            border: "1px solid #000000",
            textAlign: "center",
            margin: "10px",
            overflow:"overlay"
        }

        let firstStageContainerStyle = {
            display:"flex",
            height:"85%",
            flexDirection:"column",
            alignItems:"center",
            overflow:"overlay",
            backgroundColor: "#f5f5dc",
            border: "1px solid black",
            borderRadius: "4px",
            marginTop: "18px"
        }

        // let optionBufferAreaStyle = {
        //     backgroundColor:this.props.bgColor,
        //     width:"450px",
        //     height:"50px",
        //     color:"white",
        //     fontFamily:"Microsoft JhengHei",
        //     borderStyle:"soild",
        //     borderWidth:1,
        //     borderColor:"black",
        //     textAlign:"center",
        //     fontSize:15,
        //     lineHeight:"30px",
        //     margin:5,
        // }

        let tempProps = {
            id:99,
            title:"bufferArea",
            route:"bufferArea",
        }

        return(
            
            <div style={{display:"flex"}} onMouseMove={this.onMouseMove}> 
                {this.props.sessionAvaliable? <Prompt message={"暫存靜態頁面編輯更新已儲存"}/>:null}
                <Modal open={this.state.showStaticPageCheck} onClose={this.closeStaticPageCheckModal}>
                    {this.state.showStaticPageCheck? <StaticPageCheck  fieldCheck={this.staticPageAllCheck()} closeModal={this.closeStaticPageCheckModal} updateDB={this.updateDB} />:null}
                </Modal>
                <div style={firstStageParentContainerStyle}> 
                    <Button className={classes.textLink} startIcon={<AddBoxIcon/>} onClick={this.addNewFirst}>
                        {'新增第一階選項'}
                    </Button>
                    <DeleteArea mousePos={this.state.mousePos} otherDragging={this.state.containerDragging.conID} detectDirection={"y"} areaHeight={40} fontSize={15} getDeleteSequence={this.getDeleteSequence}/>
                    <div style={firstStageContainerStyle}>
                        {this.createFirstStageOption()}
                        <FirstStageOption key={tempProps.id} mousePos={this.state.mousePos} optionInfo={tempProps} sequence={"last"} bgColor={null} containerDragging={this.containerDragging} otherDragging={this.state.containerDragging.conID} getHoverMsg={this.getHoverMsg} getTitleAndRoute={this.getTitleAndRoute}/>
                    </div>
                </div>
                <div style={secondStageParentContainerStyle}>
                    {this.createSecondStageGroup()}
                </div>
            </div>
        )
    }
}

export default withStyles(wStyles)(StaticPageBody)